import { options as n, Fragment as o, Component as e } from "preact";
"undefined" != typeof window && window.__PREACT_DEVTOOLS__ && window.__PREACT_DEVTOOLS__.attachPreact("10.5.5", n, {
  Fragment: o,
  Component: e
});